module.exports = __webpack_public_path__ + "static/img/16.e38e78b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/16.png
// module id = 0X+n
// module chunks = 0